
import React, { useState, useEffect ,useRef} from 'react'
import SideBar from '../common/SideBar'
import { useDispatch, useSelector } from 'react-redux'
import { GoLocation } from "react-icons/go";
import JobCardSkeleton from '../../auth/LandingPage/JobCardSkeleton';
import { createJobPost } from '../../../services/operations/JobPostAPI';
import { createBulkJobPost } from '../../../services/operations/JobPostAPI';
import { toast } from 'react-toastify';

const ScrapJob = () => {

  const [jobs, setJobs] = useState([]);
  const [progressStep, setProgressStep] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [datePosted, setDatePosted] = useState('week');

  const [keyword, setKeyword] = useState('');
  const [location, setLocation] = useState('');
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const user = useSelector((state) => state.profile.user);
  const autocompleteRef = useRef(null);
    const autocompleteInstanceRef = useRef(null)
  const steps = [
    "Fetching all available jobs",
    "Lining up the jobs for posting",
    "Queuing them for live",
  ];


    useEffect(() => {
      if (!window.google || !window.google.maps) return;
      if (!autocompleteInstanceRef.current && autocompleteRef.current) {
        autocompleteInstanceRef.current = new window.google.maps.places.Autocomplete(
          autocompleteRef.current,
          {
          types: ['geocode'],
          fields: ['address_components', 'formatted_address', 'place_id'],
        }
        );
        autocompleteInstanceRef.current.addListener("place_changed", () => {
          const place = autocompleteInstanceRef.current.getPlace();
          if (place && place.formatted_address) {
            setLocation(place.formatted_address);
          }
        });
      }
    }, []);


  const fetchLinkedInJobs = async () => {
    setLoading(true);
    setProgressStep(0);
    try {
      const response = await fetch(
        `https://linkedin-scraper-api-real-time-fast-affordable.p.rapidapi.com/jobs/search?keywords=${encodeURIComponent(keyword)}&location=${encodeURIComponent(location)}&date_posted=${datePosted}&page_number=1`,
        {
          method: 'GET',
          headers: {
            'x-rapidapi-host': 'linkedin-scraper-api-real-time-fast-affordable.p.rapidapi.com',
            'x-rapidapi-key': process.env.REACT_APP_LINKEDIN_JOB_SCRAPER
          }
        }
      );
      const data = await response.json();
      let fetchedJobs = data?.data?.jobs || [];

      if(data.success===true){
        setProgressStep(1);
        setJobs(fetchedJobs);
      }
      else if(data.success===false){
        setProgressStep(-1);
        setKeyword("");
        setLocation("");
        toast.error(data.message);
        return;
      }
    
      await dispatch(createBulkJobPost(fetchedJobs, token, () => { 
         setProgressStep(2)  
         setTimeout(() => {
    setProgressStep(-1); 
      setKeyword("")
      setLocation("")
  }, 4000);
        }));

    } catch (error) {
      console.error('Error fetching LinkedIn jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchLinkedInJobs();



  };

  function getRelativeDate(dateString) {
    const inputDate = new Date(dateString);
    const today = new Date();

    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffInMs = today - inputDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    if (diffInDays > 1) return `${diffInDays} days ago`;
    if (diffInDays === -1) return "Tomorrow";
    if (diffInDays < -1) return `In ${Math.abs(diffInDays)} days`;

    return dateString;
  }


  const postJob = async (job) => {
    const payload = {
      company_name: job?.company,
      job_title: job?.job_title,
      job_location: job?.location,
      workplace_type: job?.work_type,
      employment_type: job?.job_insights[2] || "on-site",
      industries: job?.industry || "",
      description: job?.description,
      experience: job?.experience || "",
      salary_range: job?.salary || "",
      skills: job?.skills || [],
      job_status: "ACTIVE",
    }

    await dispatch(createJobPost(payload, token, () => { }))
  }


  return (
    <div className="admin-dashboard-container">
      <SideBar user={user} />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-heading">
          <h5 style={{ fontSize: "24px", fontWeight: "600" }}>Scrap Jobs from linkedin</h5>
        </div>
        <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
          <form onSubmit={handleSearch} style={{ marginBottom: '20px', display: "flex" }}>
            <input
              type="text"
              placeholder="Keyword (e.g., Java Developer)"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              style={{ padding: '8px', width: '45%', marginRight: '10px', borderRadius: "15px", border: "0.5px solid #d9d9d9", height: "45px" }}
            />
              <input
                  ref={autocompleteRef}
                  placeholder='Search by country (e.g.,United States)'
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  autoComplete="off"
                    onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                  style={{ padding: '8px', width: '45%', marginRight: '10px', borderRadius: "15px", border: "0.5px solid #d9d9d9", height: "45px" }}
                />
            <select
              value={datePosted}
              onChange={(e) => setDatePosted(e.target.value)}
              style={{
                padding: '8px',
                borderRadius: '10px',
                border: '0.5px solid #d9d9d9',
                height: '45px',
                marginRight: '10px',
                width: '25%',
              }}
            >
              <option value="day">Past 24 hour</option>
              <option value="week">Past Week</option>
              <option value="month">Past Month</option>
            </select>

            <button type="submit"
              disabled={!keyword || !location}
              style=
              {{
                padding: '8px 16px', borderRadius: "10px", height: "45px", backgroundColor: "#0002DC", color: "white", border: "none", width: "35%", fontSize: "18px", cursor: (!keyword || !location) ? "not-allowed" : "pointer",
                opacity: (!keyword || !location) ? 0.6 : 1,
              }}>Search & Post Job</button>
          </form>
        </div>
      <div className="progress-container-vertical">
  {steps.map((step, index) => (
    <div className="progress-step-vertical" key={index}>
      <div className="circle-line-wrapper">
        <div className={`circle-vertical-wrapper ${progressStep >= index ? 'active' : ''}`}></div>
        {index !== steps.length - 1 && (
          <div className={`vertical-line-wrapper ${progressStep > index ? 'active' : ''}`}></div>
        )}
      </div>
      <p className={`step-text-vertical ${progressStep >= index ? 'active' : ''}`}>{step}</p>
    </div>
  ))}
</div>


      </div>
    </div>

  )
}

export default ScrapJob